module.exports = __webpack_public_path__ + "static/media/facing.05d6ea94.png";